import type { RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "gestion/actividades",
    name: "activities",
    component: () => import("./pages/ActivitiesPage.vue"),
    meta: {
      roles: ["ADMIN", "TECNICO"],
      titleKey: "menu.activities",
      requiresAuth: true,
      requiresStaff: true,
    },
  },
  {
    path: "gestion/actividades/:id",
    name: "activity-detail",
    component: () => import("./pages/ActivityDetailPage.vue"),
    meta: {
      roles: ["ADMIN", "TECNICO"],
      titleKey: "menu.activities",
      requiresAuth: true,
      requiresStaff: true,
    },
  },
  {
    path: "my-activities",
    name: "my-activities",
    component: () => import("./pages/FamilyActivitiesPage.vue"),
    meta: {
      titleKey: "menu.my_activities",
      requiresAuth: true,
    },
  },
];
